import React, { useState, useEffect } from "react";
// components
import { MasterMaintenanceSearchBox } from "./MasterMaintenance.SearchBox";
import { MasterMaintenanceItemMasterThead } from "./MasterMaintenance.ItemMaster.Thead";
import { MasterMaintenanceItemMasterTbody } from "./MasterMaintenance.ItemMaster.Tbody";
import { TabKey } from "../MasterMaintenance.constants";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// UI
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TablePagination from "@material-ui/core/TablePagination";
// hook
import { useStyles } from "../hooks/table.useStyles";

export const MasterMaintenanceItemMaster = (props: any) => {
  const classes = useStyles();
  const [searchKey, setSearchKey] = useState("");
  const { t } = useLocale({
    defaultPath: "modules.components.MasterMaintenance.itemMaster",
  });
  const { itemMasterData, itemMasterResultList } = props;
  // pager
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // page
  const pageInfo = {
    page: page,
    rowsPerPage: rowsPerPage,
  };

  // order
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // search
  const handleChangeKey = (value: any) => {
    setSearchKey(value);
    props.SearchResult(value, TabKey.itemMaster);
    setPage(0);
  };

  const handleSearch = () => {
    props.SearchResult(searchKey, TabKey.itemMaster);
    setPage(0);
  };

  // message box
  const [open, setOpen] = useState(false);
  const handleSend = () => {
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <MasterMaintenanceSearchBox
        searchKey={searchKey}
        handleChangeKey={handleChangeKey}
        handleSearch={handleSearch}
      />
      <TableContainer>
        <Table className={classes.table}>
          <MasterMaintenanceItemMasterThead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <MasterMaintenanceItemMasterTbody
            data={itemMasterResultList}
            pageInfo={pageInfo}
            order={order}
            orderBy={orderBy}
            handleEdit={props.handleEdit}
          />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 40, 60]}
        component="div"
        count={itemMasterResultList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage={t("label_rows_per_page")}
      />
    </div>
  );
};
